import { useTranslation } from 'react-i18next';
import { urlDeAcceso } from '../session/acceso';

type Estado = 'pendiente' | 'rechazado' | 'retirado';
const TIPOS = ['PHONE', 'TABLET', 'COMPUTER', 'UNKNOWN'] as const;

/**
 * Entró bien, pero desde un dispositivo que no está aprobado (ADR-0026). No hay
 * sesión: esto es todo lo que ve. Si espera, que sepa que se mandó a aprobar y
 * que le llegará un correo con la respuesta; si se lo negaron, que lo sepa
 * también, en vez de volver a la portada sin explicación.
 */
export function DispositivoPendiente() {
  const { t } = useTranslation();
  const parametros = new URLSearchParams(window.location.search);
  const crudo = parametros.get('estado');
  const estado: Estado = crudo === 'rechazado' || crudo === 'retirado' ? crudo : 'pendiente';
  const tipo = TIPOS.find((uno) => uno === parametros.get('tipo')) ?? 'UNKNOWN';
  const espera = estado === 'pendiente';

  return (
    <div className="acceso acceso--sola">
      <section className="acceso__tarjeta">
        <span className="acceso__institucion">{t('app.institution')}</span>
        <span className={`acceso__sello${espera ? '' : ' acceso__sello--critico'}`} aria-hidden="true">
          <svg viewBox="0 0 48 48" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="1.4">
            <rect x="15" y="6" width="18" height="36" rx="3" />
            <path d="M21 36h6" />
            {espera ? <path d="M24 15v7l4 3" /> : <path d="m20 17 8 8m0-8-8 8" />}
          </svg>
        </span>
        <h1 className="acceso__tarjeta-titulo">{t(`devicePending.${estado}.title`)}</h1>
        <p className="acceso__tarjeta-texto">{t(`devicePending.${estado}.text`)}</p>

        <div className="datos" style={{ width: '100%' }}>
          <div className="dato">
            <span className="dato__etiqueta">{t('devicePending.device')}</span>
            <span className="dato__valor">{t(`devices.kind.${tipo}`)}</span>
          </div>
        </div>

        {espera && <p className="campo__ayuda">{t('devicePending.whatIsADevice')}</p>}

        {/* Esperando, volver a intentar es lo que hará cuando le llegue el correo. */}
        <a className="boton boton--grande acceso__boton" href={espera ? urlDeAcceso() : '/'}>
          {t(espera ? 'devicePending.tryAgain' : 'devicePending.backHome')}
        </a>
      </section>
    </div>
  );
}
